import Link from '@tiptap/extension-link';

/**
 * How links behave in both editors.
 *
 * ── The bleeding bug ───────────────────────────────────────────────────────
 *
 * A ProseMirror mark is INCLUSIVE by default, which means the cursor sitting
 * at the end of a marked run is treated as still inside it — so everything
 * typed after a link becomes part of the link. Type an email address, press
 * space, keep writing, and the rest of the sentence is silently a hyperlink
 * to that address.
 *
 * `inclusive: false` puts the boundary at the end of the marked text: the
 * cursor after a link is outside it, and new typing is plain.
 *
 * ── Why it is an extend() and not an option ────────────────────────────────
 *
 * `inclusive` is a ProseMirror MARK SCHEMA property, not a Tiptap option.
 * Passing it to Link.configure(), or through StarterKit's `link:` option,
 * type-checks and does nothing at all — the schema keeps the default and the
 * bleeding continues. Only extending the mark reaches it. A test builds a real
 * editor and reads schema.marks.link.spec.inclusive, because that is the only
 * place the difference is visible.
 *
 * autolink is not the fix either: it controls whether a typed URL BECOMES a
 * link and has nothing to say about the text after one, which is why turning
 * it off looks like a fix and is not.
 */

/** Link with the mark boundary closed. Registered instead of StarterKit's. */
export const NonInclusiveLink = Link.extend({ inclusive: false });
export const LINK_OPTIONS = {
  /** A typed or pasted URL becomes a link on its own. */
  autolink: true,
  linkOnPaste: true,
  /**
   * Clicking a link inside the editor puts the caret there rather than
   * navigating. Following a link while editing loses whatever was unsaved.
   */
  openOnClick: false,
  HTMLAttributes: {
    class: 'rich-link',
    rel: 'noopener noreferrer',
    target: '_blank',
  },
} as const;
